import React, { useLayoutEffect, useRef } from "react";
import "./CenteredTextarea.css";

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
}

export const CenteredTextarea: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
  className,
}) => {
  const ref = useRef<HTMLTextAreaElement | null>(null);

  const adjust = () => {
    const ta = ref.current;
    if (!ta) return;
    // Reset height to measure content height
    ta.style.paddingTop = "0px";
    // use a temporary clone to measure rendered height with wrapping
    const clone = document.createElement("div");
    const style = getComputedStyle(ta);
    clone.style.position = "absolute";
    clone.style.visibility = "hidden";
    clone.style.width = ta.offsetWidth + "px";
    clone.style.font = style.font;
    clone.style.lineHeight = style.lineHeight;
    clone.style.whiteSpace = "pre-wrap";
    clone.style.wordWrap = "break-word";
    clone.textContent = ta.value || ta.placeholder || " ";
    document.body.appendChild(clone);
    const textHeight = clone.offsetHeight;
    document.body.removeChild(clone);
    const totalHeight = ta.clientHeight;
    const paddingTop = Math.max(Math.floor((totalHeight - textHeight) / 2), 0);
    ta.style.paddingTop = paddingTop + "px";
  };

  useLayoutEffect(() => {
    adjust();
    // adjust on window resize to keep centered
    const handler = () => adjust();
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [value, placeholder]);

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={
        className ? `centered-textarea ${className}` : "centered-textarea"
      }
    />
  );
};

export default CenteredTextarea;
